module.exports = __webpack_public_path__ + "img/家用电器3.d1eb3623.jpg";